

(function () {
  var TTL_DAYS = 30;
  var SCRIPT_V = 11;
  // Universal — same for every Flux store.
  var AUTO = /^(utm_[a-z0-9_]+|gclid|fbclid|ttclid|msclkid|twclid|li_fat_id)$/;
  // Merchant-owned — from settings.attribution.tracked_params at script bake time.
  var EXTRA = [];

  function clean(v) {
    return String(v).trim().toLowerCase().slice(0, 100);
  }

  function isTracked(key) {
    if (AUTO.test(key)) return true;
    for (var i = 0; i < EXTRA.length; i++) if (EXTRA[i] === key) return true;
    return false;
  }

  var store = {
    set: function (k, v) {
      try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
      document.cookie = k + '=' + encodeURIComponent(JSON.stringify(v)) +
        ';path=/;max-age=' + (TTL_DAYS * 86400) + ';SameSite=Lax';
    },
    get: function (k) {
      try {
        var ls = localStorage.getItem(k);
        if (ls) return JSON.parse(ls);
      } catch (e) {}
      var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)'));
      if (!m) return null;
      try { return JSON.parse(decodeURIComponent(m[1])); } catch (e) { return null; }
    }
  };

  // One-time migrate v7 pv_* → flux_* (copy only; leave legacy for ~3 weeks of in-flight sessions).
  if (!store.get('flux_first') && store.get('pv_first')) store.set('flux_first', store.get('pv_first'));
  if (!store.get('flux_last') && store.get('pv_last')) store.set('flux_last', store.get('pv_last'));
  window.__fluxAttrStore = store;

  var q = new URLSearchParams(location.search);
  var hit = {};
  q.forEach(function (v, k) {
    var key = String(k).toLowerCase();
    if (v && isTracked(key)) hit[key] = clean(v);
  });

  // No ad click in the URL — try referrer. Direct / same-site → leave storage alone.
  if (!Object.keys(hit).length) {
    var ref = document.referrer || '';
    var host = '';
    var locHost = location.hostname.replace(/^www\./, '');
    try { host = ref ? new URL(ref).hostname.replace(/^www\./, '') : ''; } catch (e) { host = ''; }
    if (!host || host === locHost || host.slice(-(locHost.length + 1)) === '.' + locHost) return;
    if (/google\./.test(host))         hit = { utm_source: 'google',    utm_medium: 'organic'  };
    else if (/instagram\./.test(host)) hit = { utm_source: 'instagram', utm_medium: 'referral' };
    else if (/facebook\./.test(host))  hit = { utm_source: 'facebook',  utm_medium: 'referral' };
    else                               hit = { utm_source: host,        utm_medium: 'referral' };
  }

  hit.ts = new Date().toISOString();
  hit.landing = location.pathname.slice(0, 100);
  hit.v = SCRIPT_V;

  store.set('flux_last', hit);
  if (!store.get('flux_first')) store.set('flux_first', hit);
})();

(function() {
  console.log("Flux Checkout script starting...");

  // 🔥 EMBEDDED SETTINGS: Set at script generation time (no runtime API calls)
  const CHECKOUT_ENABLED = true;
  const CHECKOUT_APP_URL = "https://app.flux-shopify.com";
  const MERCHANT_ID = "ywqqyu-um";

  // Early exit if checkout is disabled (prevents any overhead)
  if (!CHECKOUT_ENABLED) {
    console.log("Flux: Checkout disabled for this merchant");
    return;
  }

  // Cart retry constants
  const CART_RETRY_DELAY = 300; // Base delay for cart retries
  const CART_MAX_RETRIES = 5; // Max cart fetch attempts
  const CART_WAIT_AFTER_ADD = 1200; // Wait after add-to-cart for Buy It Now

  // Read a cookie set on the storefront domain (used for Meta's _fbc/_fbp).
  function getFluxCookie(name) {
    const parts = ("; " + document.cookie).split("; " + name + "=");
    return parts.length === 2 ? parts.pop().split(";").shift() : undefined;
  }

  // Read flux_first / flux_last written by the capture snippet above.
  // Falls back to legacy pv_* keys from SCRIPT_LOGIC_VERSION 7.
  function fluxAttrGet(key) {
    var legacy = key === 'flux_first' ? 'pv_first' : key === 'flux_last' ? 'pv_last' : null;
    var keys = legacy ? [key, legacy] : [key];
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      try {
        if (window.__fluxAttrStore && typeof window.__fluxAttrStore.get === 'function') {
          var fromStore = window.__fluxAttrStore.get(k);
          if (fromStore) return fromStore;
        }
      } catch (e) {}
      try {
        var ls = localStorage.getItem(k);
        if (ls) return JSON.parse(ls);
      } catch (e) {}
      try {
        var raw = getFluxCookie(k);
        if (raw) return JSON.parse(decodeURIComponent(raw));
      } catch (e) {}
    }
    return null;
  }

  // UA visible + _flux_* machine attrs for Shopify «Додаткові відомості».
  // Written on the STORE domain before the cross-origin checkout redirect.
  function buildFluxSourceAttributes() {
    var last = fluxAttrGet('flux_last') || {};
    var first = fluxAttrGet('flux_first') || {};
    var dash = '—';
    var trunc = function (v) {
      v = String(v == null ? '' : v);
      return v.length > 255 ? v.slice(0, 255) : v;
    };
    var attrs = [
      { key: 'Канал', value: (last.utm_source || 'direct') + ' / ' + (last.utm_medium || 'none') },
      { key: 'Кампанія', value: last.utm_campaign || dash },
      { key: 'Креатив', value: last.utm_content || dash },
      { key: 'Група', value: last.utm_term || dash },
      { key: 'Майданчик', value: last.pv_platform || dash },
      { key: 'ID оголошення', value: last.pv_ad_id || last.utm_id || dash },
      { key: 'Перший візит', value: (first.utm_source || 'direct') + ' / ' + (first.utm_campaign || dash) },
      { key: 'Дата першого візиту', value: (first.ts || '').slice(0, 10) || dash },
      { key: '_flux_utm_source', value: last.utm_source || '' },
      { key: '_flux_utm_medium', value: last.utm_medium || '' },
      { key: '_flux_utm_campaign', value: last.utm_campaign || '' },
      { key: '_flux_utm_content', value: last.utm_content || '' },
      { key: '_flux_gclid', value: last.gclid || '' },
      { key: '_flux_fbclid', value: last.fbclid || '' },
      { key: '_flux_script_version', value: last.v != null ? String(last.v) : '' }
    ];
    // Merchant extras → _flux_{key}
    Object.keys(last).forEach(function (k) {
      if (!k || k === 'v' || k === 'ts' || k === 'landing') return;
      if (k.indexOf('utm_') === 0) return;
      if (k === 'gclid' || k === 'fbclid' || k === 'ttclid' || k === 'msclkid' || k === 'twclid' || k === 'li_fat_id') return;
      if (last[k]) attrs.push({ key: '_flux_' + k, value: String(last[k]) });
    });
    attrs = attrs.filter(function (a) {
      return a.key === 'Канал' || (a.value && a.value !== dash);
    }).slice(0, 24);

    var map = {};
    attrs.forEach(function (a) { map[a.key] = trunc(a.value); });
    return map;
  }

  // Best-effort: stamp attributes onto the Online Store cart before handoff.
  // Short timeout — never block checkout if /cart/update.js is slow.
  async function syncFluxCartAttributes() {
    try {
      var attributes = buildFluxSourceAttributes();
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = controller ? setTimeout(function () { controller.abort(); }, 1500) : null;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes }),
        signal: controller ? controller.signal : undefined
      });
      if (timer) clearTimeout(timer);
    } catch (e) {
      console.warn('Flux: cart attribute sync skipped:', e);
    }
  }

  // Helper to build checkout URL with cart data
  async function getFluxCheckoutUrl(retryCount = 0) {
    try {
      // Stamp attribution onto the cart before we read it / leave the store domain.
      if (retryCount === 0) {
        await syncFluxCartAttributes();
      }

      // Force fresh cart data, no cache
      const response = await fetch('/cart.js', {
        cache: 'no-cache',
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      });
      const cart = await response.json();

      console.log("Flux: Cart fetched:", {
        itemCount: cart.items?.length,
        hasToken: !!cart.token,
        firstItem: cart.items?.[0]?.variant_id,
        attempt: retryCount + 1
      });

      // If cart is empty and we haven't retried yet, try again with exponential backoff
      if ((!cart.items || cart.items.length === 0) && retryCount < CART_MAX_RETRIES) {
        // Exponential backoff: 300ms, 600ms, 1200ms, 2400ms, 4800ms
        const delay = CART_RETRY_DELAY * Math.pow(2, retryCount);
        console.log(`Flux: Cart empty, retrying in ${delay}ms (attempt ${retryCount + 2}/${CART_MAX_RETRIES + 1})`);
        await new Promise(resolve => setTimeout(resolve, delay));
        return getFluxCheckoutUrl(retryCount + 1);
      }

      // Final check after retries
      if (!cart.items || cart.items.length === 0) {
        console.warn("Flux: Cart is empty after all retries");
        if (window.fluxCheckoutIntentional) {
          alert("Your cart is empty. Please add items before checking out.");
          window.fluxCheckoutIntentional = false;
        }
        return null;
      }

      const checkoutUrl = new URL(`${CHECKOUT_APP_URL}/checkout/${MERCHANT_ID}`);

      const items = cart.items.map(item => `${item.variant_id}:${item.quantity}`).join(',');
      checkoutUrl.searchParams.append('items', items);
      checkoutUrl.searchParams.append('currency', cart.currency || 'UAH');

      // Pass cart token/ID for clearing after successful payment
      if (cart.token) {
        checkoutUrl.searchParams.append('cart_id', cart.token);
      }

      // Capture cart note from the form (universal approach for any Shopify theme)
      const noteField = document.querySelector('textarea[name="note"]') ||
                       document.querySelector('input[name="note"]') ||
                       document.querySelector('[name="note"]');

      if (noteField && noteField.value && noteField.value.trim()) {
        console.log("Flux: Found cart note:", noteField.value.trim());
        checkoutUrl.searchParams.append('note', noteField.value.trim());
      } else {
        console.log("Flux: No cart note found");
      }

      // Forward Meta's click id / browser id to the checkout.
      //
      // The pixel writes _fbc/_fbp as cookies on THIS domain. When the checkout is
      // served from a domain that does not share them (flux-checkout.vercel.app, or
      // a custom checkout domain that is not a subdomain of the store root), the
      // checkout cannot read them at all — so its server-side events go out with no
      // fbc, and Meta cannot tie the purchase to the ad click that produced it. The
      // storefront is the only place these values exist, so pass them along.
      const fbc = getFluxCookie('_fbc');
      const fbp = getFluxCookie('_fbp');
      if (fbc) checkoutUrl.searchParams.append('fbc', fbc);
      if (fbp) checkoutUrl.searchParams.append('fbp', fbp);
      // No _fbc cookie (pixel blocked or not yet written)? On the landing pageview
      // the raw click id is still in the URL — hand it over and let the checkout
      // assemble fbc itself.
      if (!fbc) {
        const fbclid = new URL(window.location.href).searchParams.get('fbclid');
        if (fbclid) checkoutUrl.searchParams.append('fbclid', fbclid);
      }

      // Forward first/last-touch JSON across the domain gap. localStorage/cookies on
      // the store origin are invisible on the checkout host — the cart attributes we
      // just wrote do not travel with the items= handoff either, so the URL is the
      // source of truth for captureAttribution() on the checkout page.
      try {
        var fluxFirst = fluxAttrGet('flux_first');
        var fluxLast = fluxAttrGet('flux_last');
        if (fluxFirst) checkoutUrl.searchParams.append('flux_first', JSON.stringify(fluxFirst));
        if (fluxLast) checkoutUrl.searchParams.append('flux_last', JSON.stringify(fluxLast));
        // Flat mirrors for the items→token redirect's ATTRIBUTION_PARAMS allowlist.
        if (fluxLast) {
          if (fluxLast.utm_source) checkoutUrl.searchParams.append('utm_source', fluxLast.utm_source);
          if (fluxLast.utm_medium) checkoutUrl.searchParams.append('utm_medium', fluxLast.utm_medium);
          if (fluxLast.utm_campaign) checkoutUrl.searchParams.append('utm_campaign', fluxLast.utm_campaign);
          if (fluxLast.utm_content) checkoutUrl.searchParams.append('utm_content', fluxLast.utm_content);
          if (fluxLast.utm_term) checkoutUrl.searchParams.append('utm_term', fluxLast.utm_term);
          if (fluxLast.gclid) checkoutUrl.searchParams.append('gclid', fluxLast.gclid);
          if (fluxLast.fbclid && !checkoutUrl.searchParams.get('fbclid')) {
            checkoutUrl.searchParams.append('fbclid', fluxLast.fbclid);
          }
        }
      } catch (e) {
        console.warn('Flux: attribution forward skipped:', e);
      }

      console.log("Flux: Built checkout URL with items:", items);
      return checkoutUrl.toString();
    } catch (error) {
      console.error("Flux: Cart fetch failed:", error);
      if (window.fluxCheckoutIntentional && retryCount >= 2) {
        alert("Failed to load cart. Please refresh the page and try again.");
        window.fluxCheckoutIntentional = false;
      }
      return null;
    }
  }

  // Selectors that identify cart-count badge elements across themes.
  const FLUX_CART_COUNT_SELECTORS = [
    '.cart-count-bubble', '.cart-count', '.cart-item-count', '.cart-item-count-bubble',
    '#cart-icon-bubble .cart-count-bubble', '[data-cart-count]', '.cart-link__bubble',
    '.header__cart-count', '.site-header__cart-count', '.js-cart-count', '.cart-qty',
    '.cart_count', '.cart-counter', '.cart-count-badge'
  ];
  // Selectors that identify cart markup (drawer / cart-page item list) across themes.
  // Used to detect which page sections need re-rendering after the cart is emptied.
  const FLUX_CART_MARKER_SELECTORS = FLUX_CART_COUNT_SELECTORS.concat([
    'cart-drawer', '#CartDrawer', '.cart-drawer', '#cart-drawer', '.drawer--cart',
    '.mini-cart', '.minicart', '.ajaxcart', '#cart-icon-bubble',
    'cart-items', '#main-cart-items', '.cart-items', '.cart__items', '#cart-items',
    '[data-cart-items]'
  ]);

  // Set every cart-count badge to "0" synchronously. NEVER hide/remove the element:
  // many themes keep the cart icon's badge permanently visible (showing "0" when empty),
  // so hiding it makes the whole cart icon vanish until the next reload.
  function setCartCountToZero() {
    try {
      document.querySelectorAll(FLUX_CART_COUNT_SELECTORS.join(',')).forEach(function(el) {
        el.textContent = '0';
      });
    } catch (e) { /* ignore */ }
  }

  // Replace a stale section element with freshly-rendered HTML from the Section
  // Rendering API. The response may or may not include the .shopify-section wrapper,
  // so handle both shapes.
  function fluxSwapSection(el, html, sectionId) {
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const wrapper = doc.getElementById('shopify-section-' + sectionId) ||
        doc.querySelector('.shopify-section');
      if (wrapper) {
        el.outerHTML = wrapper.outerHTML;
      } else {
        el.innerHTML = html;
      }
    } catch (e) {
      try { el.innerHTML = html; } catch (e2) { /* ignore */ }
    }
  }

  // Decide whether a Shopify section holds cart UI we should re-render after a clear.
  // Mainstream themes expose a known marker class, but many custom themes match none of
  // them — e.g. the drawer rendered as a "quick-cart"/"mini-cart" section, or driven by a
  // <shop-cart-sync> / <cart-drawer> web component. So detect cart sections broadly:
  //   1. the section id names the cart (quick-cart, mini-cart, cart-drawer, ajax-cart…);
  //   2. it carries known cart markup (drawer / item list / count badge);
  //   3. it holds a header link to /cart (so the count badge's section re-renders too);
  //   4. it holds a custom element whose tag mentions cart/drawer (the theme's cart sync).
  function fluxSectionHasCart(sec) {
    try {
      if (sec.id.toLowerCase().indexOf('cart') !== -1) return true;
      if (sec.querySelector(FLUX_CART_MARKER_SELECTORS.join(','))) return true;
      if (sec.querySelector('a[href$="/cart"], a[href*="/cart?"]')) return true;
      const els = sec.getElementsByTagName('*');
      for (let i = 0; i < els.length; i++) {
        const tag = els[i].tagName;
        if (tag.indexOf('-') !== -1) {
          const lower = tag.toLowerCase();
          if (lower.indexOf('cart') !== -1 || lower.indexOf('drawer') !== -1) return true;
        }
      }
    } catch (e) { /* ignore — treat as non-cart */ }
    return false;
  }

  // Re-render the cart drawer / cart-page sections WITHOUT a page reload, so the visible
  // item list empties immediately instead of lingering until a second reload. Shopify
  // wraps every section in <div id="shopify-section-{id}">; we find the cart-related ones
  // present on THIS page and ask the Section Rendering API (in the context of the current
  // URL, where these sections are guaranteed to exist) for their fresh, now-empty markup.
  function rerenderCartSections() {
    try {
      const targets = {};
      document.querySelectorAll('[id^="shopify-section-"]').forEach(function(sec) {
        if (fluxSectionHasCart(sec)) {
          targets[sec.id.replace('shopify-section-', '')] = sec;
        }
      });
      const sectionIds = Object.keys(targets);
      if (sectionIds.length === 0) return; // unusual theme — events below + next nav handle it

      const url = new URL(window.location.href);
      url.searchParams.set('sections', sectionIds.join(','));
      fetch(url.toString(), { cache: 'no-cache' })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(data) {
          if (!data) return;
          sectionIds.forEach(function(id) {
            if (typeof data[id] === 'string' && targets[id]) {
              fluxSwapSection(targets[id], data[id], id);
            }
          });
          setCartCountToZero(); // re-assert after swap in case markup changed
        })
        .catch(function() { /* leave UI to the cart-update events / next navigation */ });
    } catch (e) { /* ignore */ }
  }

  // Reflect an emptied cart in the theme UI WITHOUT reloading the page:
  //  1. Set the count badge to "0" synchronously — instant, works on every theme.
  //  2. Re-render the cart drawer / cart-page sections via the Section Rendering API so
  //     the item list empties in place (the badge alone was previously updated, leaving
  //     the drawer showing stale items until a second reload).
  //  3. Dispatch the cart-update events for themes with their own custom listeners.
  // Every step is best-effort and strictly non-destructive — on an unusual theme the cart
  // just refreshes on the next navigation, never a reload, and nothing can break.
  function refreshCartUI() {
    try {
      setCartCountToZero();
      rerenderCartSections();
      ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function(name) {
        try {
          document.dispatchEvent(new CustomEvent(name, {
            bubbles: true,
            detail: { cart: { item_count: 0, items: [] } }
          }));
        } catch (e) { /* ignore */ }
      });
    } catch (e) { /* never break the storefront */ }
  }

  // Auto-clear a stale Online Store cart after a completed order.
  // The theme drawer reads the Online Store cart (cookie-based, /cart.js). A
  // server-side Storefront API clear cannot empty it, so we clear it here in the
  // customer's browser via /cart/clear.js (same-origin) once our app confirms this
  // cart token already produced a completed/paid order. Runs on every store page
  // load; fully fail-safe — any problem just leaves the cart untouched.
  async function clearStoreCartIfOrderCompleted() {
    try {
      // LEGACY/BACK-COMPAT: current back-to-store links are clean (no query flag) and
      // rely on the /api/cart/completed check below. This only fires for an old or
      // bookmarked link that still carries ?flux_clear_cart=1 — clear immediately and
      // strip the flag from the address bar. Harmless to keep; never set by new links.
      const here = new URL(window.location.href);
      if (here.searchParams.get('flux_clear_cart')) {
        here.searchParams.delete('flux_clear_cart');
        try {
          await fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
          });
        } catch (e) { /* ignore — the fallback below catches it on the next load */ }
        // Update the cart UI in place (no reload) and strip the flag from the address
        // bar via replaceState (no navigation, no history entry, no clear loop).
        refreshCartUI();
        try { window.history.replaceState({}, '', here.toString()); } catch (e) { /* ignore */ }
        return;
      }

      const cartRes = await fetch('/cart.js', { cache: 'no-cache' });
      if (!cartRes.ok) return;
      const cart = await cartRes.json();

      // Nothing to clear / no token to identify the cart.
      if (!cart || !cart.items || cart.items.length === 0 || !cart.token) return;

      const statusUrl = CHECKOUT_APP_URL + '/api/cart/completed?store=' +
        encodeURIComponent(MERCHANT_ID) + '&cart_id=' + encodeURIComponent(cart.token);

      const statusRes = await fetch(statusUrl, { method: 'GET' });
      if (!statusRes.ok) return; // endpoint missing/old deploy — do nothing
      const data = await statusRes.json();
      if (!data || !data.completed) return; // cart not yet converted — leave it

      // Guard per COMPLETED ORDER (not per cart token): Shopify reuses the cart token
      // after /cart/clear.js, so a token-keyed guard would block clearing a NEW order
      // placed later with the same token. Keying by order id clears each order once and
      // leaves later-added items (no new order) untouched. Persisted in localStorage so
      // it survives across sessions; also our backstop against any reload loop.
      const guardKey = 'fluxCartCleared:' + (data.orderId || cart.token);
      try {
        if (localStorage.getItem(guardKey)) return;
      } catch (e) { /* localStorage unavailable (private mode) — proceed without guard */ }

      // This cart already produced a paid/completed order → clear the stale cart.
      const clearRes = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      // If the clear didn't succeed, bail without setting the guard so the next page
      // load retries.
      if (!clearRes.ok) return;

      try { localStorage.setItem(guardKey, '1'); } catch (e) { /* ignore */ }
      console.log('Flux: cleared stale cart for completed order:', data.orderId || cart.token);

      // Reflect the now-empty cart in the theme UI without a page reload.
      refreshCartUI();
    } catch (error) {
      // Never break the storefront over cart clearing.
      console.warn('Flux: cart auto-clear skipped:', error);
    }
  }

  // Store listener references for cleanup
  let eventListenerHandler = null;
  let mutationObserver = null;

  // Re-attach listeners to dynamically added checkout buttons
  function observeDynamicContent() {
    // Feature detection: skip if MutationObserver not supported (IE10 and below)
    if (typeof MutationObserver === 'undefined') {
      console.log("Flux: MutationObserver not supported, skipping dynamic content monitoring");
      return;
    }

    // Disconnect existing observer
    if (mutationObserver) {
      mutationObserver.disconnect();
    }

    mutationObserver = new MutationObserver(function(mutations) {
      let hasNewCheckoutButtons = false;

      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) { // Element node
              // Check if added node or its children have checkout buttons
              const hasCheckout = node.matches && (
                node.matches('button[name="checkout"]') ||
                node.matches('.shopify-payment-button') ||
                node.matches('form[action*="/cart"]')
              ) || (node.querySelector && (
                node.querySelector('button[name="checkout"]') ||
                node.querySelector('.shopify-payment-button') ||
                node.querySelector('form[action*="/cart"]')
              ));

              if (hasCheckout) {
                hasNewCheckoutButtons = true;
                break;
              }
            }
          }
        }
        if (hasNewCheckoutButtons) break;
      }

      if (hasNewCheckoutButtons) {
        console.log("Flux: New checkout buttons detected, listeners already attached via event delegation");
      }
    });

    // Observe entire document for dynamic content. The script runs in <head> before
    // <body> exists, so document.body can be null — fall back to documentElement (always
    // present) to avoid throwing and aborting the rest of initialization.
    const observeTarget = document.body || document.documentElement;
    if (observeTarget) {
      mutationObserver.observe(observeTarget, {
        childList: true,
        subtree: true
      });
    }
  }

  // Initialization function to allow re-running after bfcache restore
  function initFluxCheckout() {
    // Prevent duplicate initialization
    if (window.fluxCheckoutActive) {
      console.log("Flux: Already active, skipping re-initialization");
      return;
    }

    console.log("Flux: Initializing checkout interception");

    // Set flag immediately
    window.fluxCheckoutActive = true;

    // Clean up old listener if exists (same node we attach to — see below)
    if (eventListenerHandler) {
      window.removeEventListener('click', eventListenerHandler, true);
      eventListenerHandler = null;
    }

    // Consolidated single event listener with delegation
    eventListenerHandler = async function(e) {
      // Double-submit protection
      if (window.fluxCheckoutProcessing) {
        console.log("Flux: Already processing, ignoring duplicate click");
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        return false;
      }

      const target = e.target;

      // Check for checkout button
      const isCheckoutButton = target.tagName === 'BUTTON' && target.name === 'checkout';

      // Check for Buy It Now button
      const isBuyItNow = target.tagName === 'BUTTON' && (
        target.classList.contains('shopify-payment-button__button') ||
        target.closest('.shopify-payment-button') ||
        target.closest('shopify-accelerated-checkout') ||
        target.hasAttribute('data-shopify-payment-button') ||
        target.closest('shopify-buy-it-now-button')
      );

      // Check for cart form submission
      const isCartForm = target.tagName === 'FORM' &&
        target.action.includes('/cart') && (
          target.querySelector('input[name="checkout"]') ||
          target.querySelector('button[name="checkout"]') ||
          target.querySelector('input[type="submit"][value*="heck"]') ||
          document.querySelector(`button[name="checkout"][form="${target.id}"]`)
        );

      // If not a checkout-related element, ignore
      if (!isCheckoutButton && !isBuyItNow && !isCartForm) {
        return;
      }

      console.log("Flux: Checkout action detected:", {
        isCheckoutButton,
        isBuyItNow,
        isCartForm
      });

      e.preventDefault();
      e.stopPropagation();
      // Другой чекаут-апп, оставшийся в теме, перехватывает тот же клик и уводит
      // покупателя к себе СИНХРОННО, пока мы ещё читаем /cart.js. stopPropagation
      // не спасает: он не трогает обработчики на том же узле. Гасим событие целиком —
      // раз мы взяли клик на себя, чужой редирект отработать не должен.
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      // Set processing flag with try-finally
      window.fluxCheckoutProcessing = true;
      window.fluxCheckoutIntentional = true;

      try {
        // Handle Buy It Now separately (needs to add to cart first)
        if (isBuyItNow) {
          console.log("Flux: Buy It Now button detected - intercepting!");

          const productForm = target.closest('form') || document.querySelector('form[action*="/cart/add"]');

          if (productForm) {
            console.log("Flux: Found product form, adding to cart first...");
            const formData = new FormData(productForm);

            const addResponse = await fetch(productForm.action, {
              method: 'POST',
              body: formData,
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              }
            });

            if (!addResponse.ok) {
              throw new Error('Failed to add to cart');
            }

            await addResponse.json();
            console.log("Flux: Item added to cart, waiting for cart update...");

            // Wait for cart update
            await new Promise(resolve => setTimeout(resolve, CART_WAIT_AFTER_ADD));
          } else {
            console.log("Flux: No product form found, redirecting with current cart");
          }
        }

        // Get checkout URL and redirect
        const url = await getFluxCheckoutUrl();
        if (url) {
          console.log("Flux: Redirecting to:", url);
          window.location.href = url;
        } else {
          console.error("Flux: Failed to generate checkout URL");
        }
      } catch (error) {
        console.error("Flux: Checkout interception error:", error);
        if (window.fluxCheckoutIntentional) {
          alert("Failed to process checkout. Please try again.");
        }
      } finally {
        // Always reset processing flag
        window.fluxCheckoutProcessing = false;
        window.fluxCheckoutIntentional = false;
      }

      return false;
    };

    // Attach single consolidated listener.
    // НА window, а не на document: в фазе перехвата событие идёт window -> document
    // -> ... -> кнопка, поэтому слушатель на document проигрывает любому слушателю
    // на window (так нас и перебивал сторонний чекаут-скрипт, оставшийся в теме).
    // Наш ассет грузится синхронно первым тегом в <head>, так что на window мы ещё и
    // регистрируемся раньше конкурентов.
    window.addEventListener('click', eventListenerHandler, true);

    // Also intercept form submissions
    window.addEventListener('submit', function(e) {
      if (eventListenerHandler) {
        eventListenerHandler(e);
      }
    }, true);

    // Start observing dynamic content AFTER listeners are attached
    observeDynamicContent();

    console.log("Flux: Initialization complete (checkout enabled)");
  }

  // 🚀 IMMEDIATE INITIALIZATION - No waiting for DOM
  // Why this is safe:
  // - Event listeners on window work immediately (no DOM elements needed)
  // - Capture phase intercepts events before they reach buttons
  // - MutationObserver handles dynamically added buttons
  // - No querySelectorAll() at init time, so no DOM dependency
  console.log("Flux: Initializing immediately (no DOM wait)");
  // Isolate init so a failure there can't block cart auto-clear (and vice versa).
  try { initFluxCheckout(); } catch (e) { console.warn("Flux: init error:", e); }

  // Clear a stale cart if this cart already produced a completed order (fire & forget).
  clearStoreCartIfOrderCompleted();

  // Re-initialize when page is restored from bfcache (back button)
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      console.log("Flux: Page restored from bfcache, re-initializing");
      window.fluxCheckoutActive = false; // Reset flag to allow re-init
      window.fluxCheckoutProcessing = false; // Reset processing flag
      try { initFluxCheckout(); } catch (e) { console.warn("Flux: init error:", e); }
      // Re-check on bfcache restore — the order may have completed in another tab.
      clearStoreCartIfOrderCompleted();
    }
  });

  console.log("Flux: Ready to intercept checkout");
})();

(function() {
  // ---- Flux Cabinet: send the theme's native account links to the Flux cabinet ----
  var CABINET_ENABLED = false;
  var CABINET_URL = "https://app.flux-shopify.com/cabinet/ywqqyu-um";
  if (!CABINET_ENABLED) return;

  // A link is an "account" entry point when its path has an 'account' segment:
  // covers /account, /account/login, locale prefixes (/uk/account) and the new
  // customer-account shape shop.com/<id>/account. Logout is left untouched so
  // signing out still works through Shopify. (String checks — no regex escaping.)
  function isAccountLink(a) {
    try {
      if (!a || a.tagName !== 'A' || !a.getAttribute('href')) return false;
      var path = (a.pathname || '').toLowerCase();
      if (path.indexOf('/account/logout') !== -1) return false;
      // Classic accounts: an 'account' path segment (/account, /account/login, /uk/account…).
      if (path.split('/').indexOf('account') !== -1) return true;
      // New customer accounts: the theme routes the account icon through these paths
      // (e.g. /customer_authentication/redirect) — there's no 'account' segment to match.
      if (path.indexOf('/customer_authentication') !== -1) return true;
      if (path.indexOf('/customer_account') !== -1) return true;
      return false;
    } catch (e) { return false; }
  }

  // Вход, который НЕ является ссылкой. Новые темы открывают модалку Shop своим
  // обработчиком на кнопке или веб-компоненте — href там может отсутствовать вовсе,
  // и переписывать нечего. Такие элементы ловим по разметке темы и подписи.
  var NON_LINK_ACCOUNT_SELECTOR = [
    'shop-login-button',
    '[data-shop-login]',
    '.header__icon--account',
    '.header__icon--account *',
    '[href*="/account"]',
    '[aria-label*="account" i]',
    '[aria-label*="Account" i]',
    '[aria-label*="Обліковий" i]',
    '[aria-label*="Кабінет" i]',
    '[aria-label*="Аккаунт" i]',
    '[aria-label*="Увійти" i]'
  ].join(',');

  function isAccountEntry(el) {
    try {
      if (!el || !el.closest) return false;
      if (el.closest('a[href*="/account/logout"]')) return false;
      var link = el.closest('a');
      if (link && isAccountLink(link)) return true;
      return !!el.closest(NON_LINK_ACCOUNT_SELECTOR);
    } catch (e) { return false; }
  }

  // Rewrite hrefs so hover / middle-click / open-in-new-tab also reach the cabinet.
  function rewriteLinks() {
    try {
      var links = document.querySelectorAll('a[href*="/account"], a[href*="customer_authentication"], a[href*="customer_account"]');
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        if (a.__fluxCabinet || !isAccountLink(a)) continue;
        a.__fluxCabinet = true;
        a.setAttribute('href', CABINET_URL);
      }
    } catch (e) { /* ignore */ }
  }

  // Click backstop: catches account links the theme opens via its own JS handler
  // (account drawer) AND the links rewritten above — always land on the cabinet and
  // stop the theme's handler from hijacking. Respect new-tab modifier keys.
  function intercept(e) {
    try {
      if (e.metaKey || e.ctrlKey || e.shiftKey || (e.button !== undefined && e.button !== 0)) return;
      var el = e.target;
      if (!el || !isAccountEntry(el)) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      window.location.href = CABINET_URL;
    } catch (err) { /* ignore */ }
  }

  // Перехват на pointerdown, а не только на click. Скрипт Shop грузится в <head>
  // раньше нашего ассета темы, и его обработчик клика в фазе перехвата зарегистрирован
  // первым — то есть на click мы уже опаздываем, и модалка «Sign in or create account»
  // успевает открыться. pointerdown/mousedown происходит раньше любого click, поэтому
  // очередь регистрации перестаёт иметь значение.
  document.addEventListener('pointerdown', intercept, true);
  document.addEventListener('mousedown', intercept, true);
  document.addEventListener('click', intercept, true);

  function start() { rewriteLinks(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }

  // Headers re-render often (sticky/transparent variants, drawer mounts) — keep up.
  try {
    var mo = new MutationObserver(rewriteLinks);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) { /* MutationObserver unsupported — click backstop still covers it */ }

  console.log('Flux Cabinet: account links routed to', CABINET_URL);
})();
